import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";
import { AppContext } from "../../../../AppContext";

export function useRenderVTab() {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const userRole = localStorage.getItem("UserRole");


  const createVTab = (
    id,
    menuText,
    tabtypes,
    icon
  ) => ({
    id,
    title: menuText,
    tabMenuText: selectedLanguage.LstLanguageCodes[`UI_${menuText}`],
    tabtypes,
    icon
  });

  const vTabs = [
    createVTab(1, "Profile", ["Personal"], "account_box"),
    createVTab(2, "General", ["Company", "Personal"], 'info'),
    createVTab(3, "DefaultDocumentSettings", ["Company", "Personal"], "assignment"),
    createVTab(5, "Advance", ["Company", "Personal"], "settings"),
    // ...(AppContext.ContentSecurity 
    //   ? [createVTab(6, "ContentSecurity", ["Company", "Personal"], "security")] 
    //   : []
    // ),
    createVTab(7, "Users", ["Admin"], "group"),
  ];
  if (localStorage.getItem("IsContentSecurity") === "true" && AppContext.ContentSecurity) {
    vTabs.push(createVTab(6, "ContentSecurity", ["Company", "Personal"], "security"));
  }
  if (localStorage.getItem("IsDirectSendDefaults") === "true") {
    vTabs.push(createVTab(4, "DirectSendDefaults", ["Company", "Personal"], "send"));
  }
  if (userRole === "RDocsSupportAdmin") {
    vTabs.push(createVTab(8, "Document", ["Admin"], "assignment"));
  }
  if (AppContext.ShowRPDLite && (userRole === "RDocsSupportAdmin" || userRole === "RDocsCustomerAdmin")) {
    vTabs.push(createVTab(9, "Storage", ["Company"], "storage"));
  }
  const isUser = AppContext.contactsConfigUsers?.[0]?.split(",").map(email => email.trim().toLowerCase()).filter(Boolean)
  const isConfiguredUser = (isUser.includes(localStorage.getItem("UserName")?.toLowerCase()) || AppContext.isContactsEnabled);
  if (isConfiguredUser || userRole === "RDocsSupportAdmin") {
    vTabs.push(createVTab(10, 'Contacts', ['Company', 'Personal'], 'contacts'));
  }

  vTabs.sort((a, b) => a.id - b.id);
  return vTabs;
}
